<div class="custom-form-root flex flex-col gap-4 p-4">

  <!-- Titolo -->
  <h2 class="text-2xl font-semibold text-gray-800">
    {{ data.form?.FormName }}
  </h2>

  <!-- Wrapper scrollabile -->
  <div class="relative overflow-auto border rounded-lg shadow-sm bg-white"
       [style.width.px]="wrapperWidth"
       [style.height.px]="wrapperHeight">

    <!-- Canvas dinamico -->
    <div class="canvas-wrapper relative w-full h-full">

      <ng-container *ngFor="let f of fields">

        <!-- LABEL -->
        <div *ngIf="f.ControlType === 'LABEL'"
             [ngStyle]="ctrlStyle(f)"
             class="absolute text-gray-700 text-sm font-medium">
          {{ f.DefaultValue || f.Name }}
        </div>

        <!-- TEXTBOX -->
        <input *ngIf="f.ControlType === 'TEXTBOX'"
               [formControl]="formGroup.controls[f.Name]"
               [attr.title]="f.Tooltip"
               [ngStyle]="ctrlStyle(f)"
               class="absolute border rounded px-2 py-1 text-sm w-full focus:ring focus:ring-blue-300" />

        <!-- TEXTAREA -->
        <textarea *ngIf="f.ControlType === 'TEXTAREA'"
                  [formControl]="formGroup.controls[f.Name]"
                  [attr.title]="f.Tooltip"
                  [ngStyle]="ctrlStyle(f)"
                  class="absolute border rounded px-2 py-1 text-sm w-full resize-none focus:ring focus:ring-blue-300"></textarea>

        <!-- INT / DEC TEXTBOX -->
        <input *ngIf="f.ControlType === 'INTTEXTBOX' || f.ControlType === 'DECTEXTBOX'"
               [formControl]="formGroup.controls[f.Name]"
               [attr.title]="f.Tooltip"
               [ngStyle]="ctrlStyle(f)"
               class="absolute border rounded px-2 py-1 text-sm w-full focus:ring focus:ring-blue-300"
               (keypress)="
                 (f.ControlType==='INTTEXTBOX') ?
                   (( $event.key>='0' && $event.key<='9') || $event.key==='Backspace')
                 : null
               " />

        <!-- DATEPICKER -->
        <input *ngIf="f.ControlType === 'DATEPICKER'"
               type="date"
               [formControl]="formGroup.controls[f.Name]"
               [ngStyle]="ctrlStyle(f)"
               class="absolute border rounded px-2 py-1 text-sm w-full focus:ring focus:ring-blue-300" />

        <!-- CHECKBOX -->
        <label *ngIf="f.ControlType === 'CHECKBOX'"
               [ngStyle]="ctrlStyle(f)"
               class="absolute flex items-center gap-2 text-sm text-gray-700 cursor-pointer">
          <input type="checkbox"
                 [checked]="formGroup.controls[f.Name].value"
                 (change)="formGroup.controls[f.Name].setValue($event.target.checked)"
                 class="h-4 w-4 rounded border-gray-400" />
          {{ f.Tooltip || f.Name }}
        </label>

        <!-- DROPDOWNLIST -->
        <select *ngIf="f.ControlType === 'DROPDOWNLIST'"
                [formControl]="formGroup.controls[f.Name]"
                [ngStyle]="ctrlStyle(f)"
                class="absolute border rounded px-2 py-1 text-sm bg-white w-full focus:ring focus:ring-blue-300">
          <option *ngFor="let o of parseOptions(f.Options)" [value]="o.key">
            {{ o.value }}
          </option>
        </select>

        <!-- LISTBOX -->
        <select *ngIf="f.ControlType === 'LISTBOX'"
                [ngStyle]="ctrlStyle(f)"
                multiple
                (change)="onMultiSelectChange($event, f.Name)"
                class="absolute border rounded px-2 py-1 text-sm bg-white w-full h-full focus:ring focus:ring-blue-300">
          <option *ngFor="let o of parseOptions(f.Options)" [value]="o.key">{{ o.value }}</option>
        </select>

        <!-- FILE -->
        <div *ngIf="f.ControlType === 'FILE'"
             [ngStyle]="ctrlStyle(f)"
             class="absolute">
          <input type="file"
                 class="block text-sm text-gray-700"
                 (change)="onFileChange($event, f.Name)" />
        </div>

        <!-- IMAGE -->
        <img *ngIf="f.ControlType === 'IMAGE'"
             [src]="f.DefaultValue"
             [ngStyle]="ctrlStyle(f)"
             class="absolute object-contain rounded shadow" />

        <!-- RECTANGLE -->
        <div *ngIf="f.ControlType === 'RECTANGLE'"
             [ngStyle]="ctrlStyle(f)"
             class="absolute bg-gray-200 rounded"></div>

        <!-- BUTTON -->
        <button *ngIf="f.ControlType === 'BUTTON'"
                [ngStyle]="ctrlStyle(f)"
                class="absolute px-3 py-1 rounded text-sm bg-blue-600 text-white hover:bg-blue-700 transition"
                (click)="
                  f.Action === 'CANCEL' ? cancelForm() :
                  f.Action === 'SECONDARY' ? secondaryForm(f) :
                  f.Action === 'SUBMIT' ? submitForm(f) :
                  actionForm(f)
                ">
          {{ f.Tooltip || f.DefaultValue || f.Name }}
        </button>

      </ng-container>

    </div>
  </div>
</div>
